import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import ro from "../util/browser-detector.js";
import Qt from "../models/device.js";
import DeviceProperties from "../Core/device-properties.js";
import _t from "../models/identifier.js";
import { logger as E, Guid as P } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { values as Pt } from "../util/code-utils.js";
import { getErrorMessage as si } from "../util/error-utils.js";
var Ot = /*#__PURE__*/function () {
  function Ot(t, e) {
    _classCallCheck(this, Ot);
    this.j = t, this.Fa = e, this.j = t, null == e && (e = Pt(DeviceProperties)), this.Fa = e;
  }
  _createClass(Ot, [{
    key: "fe",
    value: function fe() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var e = this.j.tu(s.iu.Jh);
      null == e && (e = new _t(P.oe()), t && this.j.uu(s.iu.Jh, e));
      var r = new Qt(e.eu);
      for (var _t2 = 0; _t2 < this.Fa.length; _t2++) {
        switch (this.Fa[_t2]) {
          case DeviceProperties.BROWSER:
            r.browser = ro.browser;
            break;
          case DeviceProperties.BROWSER_VERSION:
            r.Ga = ro.version;
            break;
          case DeviceProperties.OS:
            r.os = this.Ja();
            break;
          case DeviceProperties.RESOLUTION:
            r.Ba = screen.width + "x" + screen.height;
            break;
          case DeviceProperties.LANGUAGE:
            r.language = ro.language;
            break;
          case DeviceProperties.TIME_ZONE:
            r.timeZone = this.Ha(new Date());
            break;
          case DeviceProperties.USER_AGENT:
            r.userAgent = ro.userAgent;
        }
      }
      return r;
    }
  }, {
    key: "Ja",
    value: function Ja() {
      if (ro.Ka()) return ro.Ka();
      var t = this.j.lt(s.ct.Qa);
      return t && t.os_version ? t.os_version : ro.Ja();
    }
  }, {
    key: "Ha",
    value: function Ha(t) {
      var e = !1;
      if ("undefined" != typeof Intl && "function" == typeof Intl.DateTimeFormat) try {
        if ("function" == typeof Intl.DateTimeFormat().resolvedOptions) {
          var _t3 = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (null != _t3 && "" !== _t3) return _t3;
        }
      } catch (t) {
        E.info("Intl.DateTimeFormat threw an error, cannot detect user's time zone:" + si(t)), e = !0;
      }
      if (e) return "";
      var r = t.getTimezoneOffset();
      return this.Va(r);
    }
  }, {
    key: "Va",
    value: function Va(t) {
      var e = Math.trunc(t / 60),
        r = Math.trunc(t % 60);
      var s = "GMT";
      return 0 !== t && (s += t < 0 ? "+" : "-", s += ("00" + Math.abs(e)).slice(-2) + ":" + ("00" + Math.abs(r)).slice(-2)), s;
    }
  }]);
  return Ot;
}();
export { Ot as default };